<!-- @format -->

<ng-container *transloco="let t">
  <fudis-dialog size="lg">
    <fudis-heading [level]="2">{{ t("PROFILE.APPLICATIONS.PAYMENT_STARTED_DIALOG.TITLE") }}</fudis-heading>
    <fudis-dialog-content>
      <fudis-grid [rowGap]="'sm'">
        <fudis-body-text [variant]="'lg-light'">{{ t("PROFILE.APPLICATIONS.PAYMENT_STARTED_DIALOG.DESCRIPTION_1") }}</fudis-body-text>
        <fudis-body-text [variant]="'lg-light'"
          >{{ t("PROFILE.APPLICATIONS.PAYMENT_STARTED_DIALOG.DESCRIPTION_2") }}
          <a
            fudisLink
            [title]="t('PROFILE.APPLICATIONS.PAYMENT_STARTED_DIALOG.EXTERNAL_INSTRUCTIONS')"
            [href]="data.instructionsUrl | localizedString"
            [external]="true"></a
        ></fudis-body-text>
        <fudis-body-text [variant]="'lg-light'">{{ t("PROFILE.APPLICATIONS.PAYMENT_STARTED_DIALOG.DESCRIPTION_3") }}</fudis-body-text>
      </fudis-grid>
    </fudis-dialog-content>
    <fudis-dialog-actions>
      <fudis-button [label]="t('SIS_COMPONENTS.BUTTON.OK')" (handleClick)="closeDialog()" />
    </fudis-dialog-actions>
  </fudis-dialog>
</ng-container>
